var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckicon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3259_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10Z",
    fill: "#444CE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7218 7.43489C12.1423 10.3313 9.44503 13.3672 9.15266 13.7254L9.11979 13.766L9.09039 13.8066C9.01475 13.9165 8.86348 13.9998 8.70124 14C8.55711 14 8.44357 13.9527 8.36397 13.883L8.29653 13.8066L5 8.77064L5.00692 8.76098C5.00928 8.75749 5.01376 8.75266 5.02076 8.74634C5.06677 8.72021 5.11863 8.70674 5.16604 8.7089C5.20399 8.71056 5.22686 8.72155 5.2404 8.73003L7.99731 11.4975L8.91917 12.4222L9.88944 11.5414L16 6C15.5833 6.46761 15.1534 6.95017 14.7218 7.43489Z",
    fill: "#6172F3",
    stroke: "white",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3259_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckicon1);
export default __webpack_public_path__ + "static/media/Checkicon__1.4b58a1f40972c80fcdaed88313a74a46.svg";
export { ForwardRef as ReactComponent };